import { atom } from "recoil";
import { ItemModalState } from "./is-not-open-for-sale-modal";

export const isNotOpenDisplayedModal = atom<ItemModalState | undefined>({
  key: "isNotOpenDisplayedModal",
  default: undefined,
});
